import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "../Header/Header.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
const StickyHeader = () => {
  // const [slide, setSlide] = useState(false);
  const [logoutMenu, setLogoutMenu] = useState(false);
  // const [scrollScreen, setScrollScreen] = useState(false);
  //   const [certificates, setCertificates] = useState([]);
  const [slide, setSlide] = useState(false);
  const [scrollScreen, setScrollScreen] = useState(false);
  const [certificates, setCertificates] = useState([]);
  
  const handleclick = () => {
    setSlide(!slide);
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/details/getCertificates`)
      .then((response) => {
        setCertificates(response.data);
      })
      .catch((error) => {
        console.error("Error fetching certificates:", error);
      });

    const handleScroll = () => {
      setScrollScreen(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  

const navigate = useNavigate();

  useEffect(() => {
    if (
      localStorage.getItem("isLoggedIn") || 
      localStorage.getItem("isInstitutionLogin")
    ) {
      navigate('/admin');
    }
    else if(localStorage.getItem("isStudentLogin")){
      navigate('/profile')
    }
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("isInstitutionLogin");
    localStorage.removeItem("isStudentLogin");

    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('username');
    localStorage.removeItem('userRole');
    localStorage.removeItem('referralid');
  
    window.location.reload(); // Reload to update the UI after logout
  };

  return (
    <div
      className="sticky-header"
      style={{
        position: scrollScreen ? "fixed" : "static",
        top: 0,
        width: "100%",
        zIndex: 100,
        backgroundColor: "white",
        transition: "0.3s ease-in-out",
        boxShadow: scrollScreen ? "0px 4px 10px rgba(0, 0, 0, 0.1)" : "none",
      }}
    >
      <div className="container-fluid">
        <div className="main-header__inner">
          {/* Logo */}
          <div className="main-header__logo">
           {/* {scrollScreen? */}
             <Link to="/" style={{  transition: "transform 0.5s ease-in-out",
    transform: scrollScreen ? "translateX(0px)" : "translateX(-200px)"}}>
             <img src="assets/logo.png" alt="Cleenhearts" width="159" />
           </Link>
           {/* : */}
           {/* <></>
           } */}
            <button
              type="button"
              className="main-header__sidebar-btn sidebar-btn__toggler"
              onClick={() => setSlide(!slide)}
            >
              <span className="icon-grid"></span>
            </button>
          </div>

          {/* Navigation */}
          <div className="main-header__right">
            <nav className="main-header__nav main-menu">
              <ul className="main-menu__list">
                <li>
                  <NavLink to="/">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/aboutus">About Us</NavLink>
                </li>
                <li className="dropdown">
                  <NavLink to="/program">Program</NavLink>
                  <ul>
                    <li>
                      <NavLink to="/trainingprogram">Training Program</NavLink>
                    </li>
                    <li>
                      <NavLink to="/studentsactivity">Students Activity</NavLink>
                    </li>
                    <li>
                      <NavLink to="/agricultureprogram">Agriculture Program</NavLink>
                    </li>
                    <li>
                      <NavLink to="/medical">Medical Program</NavLink>
                    </li>
                    <li>
                      <NavLink to="/Sportsactivities">Sports Activities</NavLink>
                    </li>
                  </ul>
                </li>
                <li className="dropdown">
                <NavLink>Certificate</NavLink>
                <ul>
                  {certificates.length > 0 ? (
                    certificates.map((certificate) => (
                      <li key={certificate.id}>
                        <a href={`${process.env.REACT_APP_API}/uploads/SubCategories/Images/${certificate.file_name}`} target="_blank" rel="noopener noreferrer">
                          {certificate.title}
                        </a>
                      </li>
                    ))
                  ) : (
                    <li></li>
                  )}
                </ul>
              </li>
                <li>
                  <NavLink >Exam Portal</NavLink>
                  <ul>
                    <li>
                      
                    </li>
                  </ul>
                </li>
                <li>
                  <NavLink to="/contact">Contact Us</NavLink>
                </li>


                {
  localStorage.getItem("isLoggedIn") || 
  localStorage.getItem("isInstitutionLogin") || 
  localStorage.getItem("isStudentLogin") ? null : (
    <li className="dropdown">
      <NavLink>Login</NavLink>
      <ul>
        {!localStorage.getItem("isLoggedIn") ? (
          <li>
            <NavLink to="/login">Admin Login</NavLink>
          </li>
        ) : localStorage.getItem("userRole") === "supperadmin" ? (
          <li>
            <NavLink to="/admin">Admin</NavLink>
          </li>
        ) : localStorage.getItem("userRole") === "admin" ? (
          <li>
            <NavLink to="/tailoring">Admin</NavLink>
          </li>
        ) : null}

        {!localStorage.getItem("isInstitutionLogin") ? (
          <li>
            <NavLink to="/institutionlogin">Institution Login</NavLink>
          </li>
        ) : (
          <li>
            <NavLink to="/institutionform">Institution</NavLink>
          </li>
        )}

        {!localStorage.getItem("isStudentLogin") ? (
          <li>
            <NavLink to="/studentlogin">Students Login</NavLink>
          </li>
        ) : null}

        {/* <li>
          <NavLink to="/signin">Register Here</NavLink>
        </li> */}
      </ul>
    </li>
  )
}


                
                {
  (localStorage.getItem("isLoggedIn") || 
   localStorage.getItem("isInstitutionLogin") || 
   localStorage.getItem("isStudentLogin")) && (
    <li className="dropdown">
     {/* <FontAwesomeIcon icon={faUser} onClick={() => setLogoutMenu(!logoutMenu)} /> */}
     <span className="d-flex user-header">
                    <img className="me-2 rounded-circle img-35" src="user.png" alt="User" />
                    <span className="flex-grow-1">
                      <span className="f-12 f-w-600">{localStorage.getItem('userRole')}</span>
                      <span className="d-block">{localStorage.getItem('username')}</span>
                    </span>
                  </span>
    <ul>
      <li>
        <NavLink to="/">Home</NavLink>
      </li>
      <li>
        <NavLink >Settings</NavLink>
      </li>
      {!localStorage.getItem('isLoggedIn') ?
      null 
      
      : (
                      localStorage.getItem('userRole') === 'supperadmin' ? (
                        <li><NavLink to="/admin">superAdmin</NavLink></li>
                      ) : localStorage.getItem('userRole') === 'admin' ? (
                        <li><NavLink to="/admin">Admin</NavLink></li>
                      ) : null
                    )}

{!localStorage.getItem("isInstitutionLogin") ? (
                      null
                    ) : (
                      <li>
                        <NavLink to="/institutionform">Institution</NavLink>
                      </li>
                    )}
      <li>
        {/* <NavLink to="">Medical Program</NavLink> */}
      </li>
      <li>
        <NavLink onClick={logout}>logout</NavLink>
      </li>
    </ul>
  </li>
  )
}

              </ul>
            </nav>

            {/* Mobile Menu Toggle */}
            <div className="mobile-nav__btn mobile-nav__toggler">
              <span></span>
              <span></span>
              <span></span>
            </div>

            {/* Cart */}
            <div className="main-header__cart">
              {/* <a href="cart.html" className="main-header__cart__link">
                <span className="icon-trolley"></span>
              </a>
              <span className="main-header__cart__quantity">0</span> */}
            </div>

            {/* Donate Button */}
            <a className="cleenhearts-btn main-header__btn">
              <div className="cleenhearts-btn__icon-box">
                <div className="cleenhearts-btn__icon-box__inner">
                  <span className="icon-donate"></span>
                </div>
              </div>
              <NavLink to="/donate">
                <span className="cleenhearts-btn__text">Donate Now</span>
              </NavLink>
            </a>
          </div>
        </div>
      </div>


       <aside
              className="sidebar-one"
              style={{
                transform: slide ? 'translateX(0)' : 'translateX(100%)',
                visibility: slide ? 'visible' : 'hidden',
                transition:
                  slide
                    ? 'transform 500ms ease 0ms, visibility 500ms ease 0ms, -webkit-transform 500ms ease 0ms'
                    : 'transform 500ms ease 500ms, visibility 500ms ease 500ms, -webkit-transform 500ms ease 500ms',
              }}
            >
              <div className="sidebar-one__overlay sidebar-btn__toggler" onClick={handleclick}></div>
              <div
                className="sidebar-one__content"
                style={{
                  transform: slide ? 'translateX(0)' : 'translateX(100%)',
                  visibility: slide ? 'visible' : 'hidden',
                  opacity: slide ? '1' : '0',
                  transition:
                    slide
                      ? 'opacity 500ms ease 500ms, visibility 500ms ease 500ms, transform 500ms ease 500ms, -webkit-transform 500ms ease 500ms'
                      : 'opacity 500ms ease 0ms, visibility 500ms ease 0ms, transform 500ms ease 0ms, -webkit-transform 500ms ease 0ms',
                }}
              >
                <span className="sidebar-one__close sidebar-btn__toggler" onClick={handleclick}>
                  <i className="fa fa-times"></i>
                </span>
                <div className="sidebar-one__logo sidebar-one__item">
                  <Link to='/' aria-label="logo image">
                    <img src="assets/logo.png" width="155" alt="logo-dark" />
                  </Link>
                </div>
                <div className="sidebar-one__about sidebar-one__item">
                  <p className="sidebar-one__about__text">
                    தமிழ்நாடு ராம்ஜி கல்வி மற்றும் பொருளாதார மேம்பாட்டு அறக்கட்டளை , பதிவு எண்: 38/2015
                  </p>
                </div>
                <div className="sidebar-one__information sidebar-one__item">
                  <h4 className="sidebar-one__title">Information</h4>
                  <ul className="sidebar-one__information__list">
                    <li>
                      <span className="sidebar-one__information__icon icon-location"></span>
                      <address className="sidebar-one__information__address">
                        <p className="sidebar-one__information__text">
                          10/26 Koothan vilai,Palappallam Post -629159,Kanniyakumari District
                        </p>
                      </address>
                    </li>
                    <li>
                      <i className="sidebar-one__information__icon icon-envelope"></i>
                      <p className="sidebar-one__information__text">
                        <a href="mailto:info@ramjitrust.org">info@ramjitrust.org</a>
                      </p>
                    </li>
                    <li>
                      <i className="sidebar-one__information__icon icon-phone"></i>
                      <p className="sidebar-one__information__text">+91 7598314641</p>
                    </li>
                  </ul>
                </div>
              </div>
            </aside>
    </div>
  );
};

export default StickyHeader;
